import apiClient from '@/api/index'

export default {
  index (params) {
    return apiClient.get('/socials', { params })
  },
  store (formData) {
    return apiClient.post('/socials', formData)
  },
  show (id, params) {
    return apiClient.get(`/socials/${id}`, { params })
  },
  update (id, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/socials/${id}`, formData)
  },
  destroy (id) {
    return apiClient.delete(`/socials/${id}`)
  }
}
